export interface IBulkUpdateCheckpointMetersPropsDto {
    /** Target by identity; falls back to `checkpointIndex` when absent. */
    checkpointId?: string;
    checkpointIndex: number;
    traveledMetersAfter: number;
}

export interface IBulkUpdateCheckpointMetersDto {
    tripId: string;
    meters: number;
    metersLastUpdatedAt: string;
    checkpoints: IBulkUpdateCheckpointMetersPropsDto[];
}
